import React, { useState } from 'react';
import { Divider } from '@material-ui/core';
import { TextInputTG } from 'views/components/formElements';
interface Props {
  onSubmit: (result: string) => void;
  onClose: () => void;
  selectOptions: string[];
  initialJoin?: string;
}

export const JoinModal: React.FC<Props> = ({ onSubmit, selectOptions, initialJoin }) => {
  const [search, setSearch] = useState('');

  return (
    <div style={{ margin: 20 }}>
      <TextInputTG
        id="label"
        placeholder="Search"
        value={search}
        onChange={(value) => setSearch(value)}
      />
      <Divider></Divider>
      <div style={{ overflowY: 'auto' }}>
        {selectOptions
          .filter((o) => !search || o.includes(search))
          .map((o) => (
            <div
              style={{
                cursor: 'pointer',
                ...(o === initialJoin ? { backgroundColor: '#777' } : {}),
              }}
              onClick={() => {
                onSubmit(o);
              }}
            >
              <div style={{ padding: 10 }}>{o}</div>
              <Divider></Divider>
            </div>
          ))}
      </div>
    </div>
  );
};
